import React, { useEffect, useRef, useState } from 'react';

const RunningText = ({ text, className = '', isActive = true }) => {
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const [shouldAnimate, setShouldAnimate] = useState(false);

    useEffect(() => {
        if (containerRef.current && textRef.current) {
            const containerWidth = containerRef.current.offsetWidth;
            const textWidth = textRef.current.scrollWidth;
            setShouldAnimate(textWidth > containerWidth);
        }
    }, [text, isActive]);

    return (
        <div ref={containerRef} className={className}>
            <span
                ref={textRef}
                style={{
                    animationDuration: shouldAnimate && isActive ? '22s' : '0s',
                    animationIterationCount:
                        shouldAnimate && isActive ? 'infinite' : 'unset',
                }}
            >
                {text}
            </span>
        </div>
    );
};

export default RunningText;
